import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { Providers } from './providers'
import { router } from './router'

export default function App() {
  return (
    <Providers>
      <Suspense fallback={<div className="flex min-h-screen items-center justify-center">页面加载中...</div>}>
        <RouterProvider router={router} />
      </Suspense>
    </Providers>
  )
}
